// @greenlight-spec: 11-observability.md#control-plane-internal-health
// @greenlight-spec: 26-versioning-update-strategy.md#release-validation
import { z } from 'zod';
import { RELEASE_VALIDATION_OUTCOMES, RELEASE_VALIDATION_SUITES, ReleaseValidationCaseSchema, ReleaseValidationDebugExcerptSchema, } from './vocabulary.js';
export const ReleaseValidationRunViewSchema = z.object({
    suite: z.enum(RELEASE_VALIDATION_SUITES),
    outcome: z.enum(RELEASE_VALIDATION_OUTCOMES),
    started_at: z.string().datetime({ offset: true }),
    finished_at: z.string().datetime({ offset: true }).nullable(),
    deadline_at: z.string().datetime({ offset: true }),
    reason: z.string().nullable(),
    failing_case: z.string().nullable(),
    failing_step: z.string().nullable(),
    cases: z.array(ReleaseValidationCaseSchema),
    debug_excerpt: ReleaseValidationDebugExcerptSchema.nullable(),
});
export const ReleaseValidationStatusSchema = z.object({
    /** The switch: the page renders nothing unless true. */
    enabled: z.boolean(),
    /** The running build, from the install; null when the install does not know it. */
    release_version: z.string().nullable(),
    /** One entry per suite that has a row for that build, `contract` before `e2e`. */
    runs: z.array(ReleaseValidationRunViewSchema).max(RELEASE_VALIDATION_SUITES.length),
});
/** No fields: the build under test is the install's, never the caller's. */
export const RerunReleaseValidationRequestSchema = z.object({}).strict();
export const RerunReleaseValidationResponseSchema = z.object({
    release_version: z.string(),
    suites: z.array(z.enum(RELEASE_VALIDATION_SUITES)),
});
//# sourceMappingURL=status.js.map